<template>
  <ion-app>
    <ion-router-outlet animated="false" />
  </ion-app>
</template>

<script>
import { IonApp, IonRouterOutlet, useBackButton, isPlatform } from "@ionic/vue";
import { defineComponent } from "vue";
import { App as CapApp } from "@capacitor/app";
import { useAuth0 } from "@auth0/auth0-vue";
import { Browser } from "@capacitor/browser";
import { redirectDeepLinkPath } from "@/utils/redirect-uri";
import router from "./router";

// import { useStore } from 'vuex';

export default defineComponent({
  name: "App",
  components: {
    IonApp,
    IonRouterOutlet,
  },

  setup() {
    useBackButton(10, () => {
      // leave empty to not trigger any back button event
    });

    const { handleRedirectCallback, getAccessTokenSilently, isAuthenticated } =
      useAuth0();
    const isNative = isPlatform("android") || isPlatform("ios");
    const isNativeBrowser = isPlatform("mobileweb");
    // const store = useStore()

    CapApp.addListener("appUrlOpen", async ({ url }) => {
      console.log("cap app url:", url);
      console.log("before capapp");

      const needRedirect = redirectDeepLinkPath(router, url);
      if (needRedirect) {
        return;
      }

      let appState = null;
      if (
        url.includes("state") &&
        (url.includes("code") || url.includes("error"))
      ) {
        const redirect = await handleRedirectCallback(url);
        appState = redirect.appState;
        console.log("appState", appState);
        console.log("after redirect capapp");
      }
      try {
        await Browser.close();
      } catch (error) {
        console.log(error);
      }

      if (url.includes("/callback")) {
        console.log("login done...");
        console.log("callback url: " + url);
        //init push notifications here
        if (isNative && !isNativeBrowser) {
          if (appState && appState.fullPathObj) {
            router.push({
              path: appState.fullPathObj.path,
              query: appState.fullPathObj.query,
              hash: appState.fullPathObj.hash,
            });
          }
        }
      } else if (url.includes("/logout")) {
        console.log("logout done...");
        window.location.href = "/";
      }
    });
    console.log("Capapp: " + isAuthenticated.value);
    // TODO hacky way to know whether the app is login before
    sessionStorage.setItem("loginBefore", isAuthenticated.value)
  },
});
</script>
